import React, { FC } from 'react';
import Button from 'components/Button';
import SignUpButton from 'components/Button/SignUpButton';
import _ from '@dh-fe/translate';
import routes from 'configs/routes';
import { useTheme } from 'contexts/ThemeContext';
import classnames from 'classnames';
import styles from '../Header.module.scss';

export const HeaderSignupButton = () => <SignUpButton size="xs" className={styles.joinUsButton} />;

export const LogInButton: FC<WithTheme> = () => {
    const { theme } = useTheme();
    return (
        <Button
            size="xs"
            type="secondary1"
            href={routes.login}
            className={classnames(styles[theme], styles.loginButton)}
        >{_`Login`}</Button>
    );
};

export interface WithTheme {}
